import { Pipe, PipeTransform } from '@angular/core';

/*
 * Convert bytes into largest possible unit.
 * Takes an precision argument that defaults to 2.
 * Usage:
 *   bytes | fileSize:precision
 * Example:
 *   {{ 1024 |  fileSize}}
 *   formats to: 1 KB
 */
@Pipe({name: 'fileSize'})
export class FileSizePipe implements PipeTransform {

  private units = [
    'bytes',
    'KB',
    'MB',
    'GB',
    'TB',
    'PB'
  ];

  transform(bytes: string = '', precision: number = 2 ) : string {
    let newByte = parseFloat(bytes);
    if ( isNaN( parseFloat( String(newByte) )) || ! isFinite( newByte ) ) return '?';

    let unit = 0;

    while ( newByte >= 1024 ) {
      newByte /= 1024;
      unit ++;
    }

    return newByte.toFixed( + precision ) + ' ' + this.units[ unit ];
  }
}
